import { MutationHookOptions, gql } from '@apollo/client';

import { edeApplicationQuery } from 'routes/marketplace-ede/queries/ede/getEdeApplication';
import { useEdeMutation, useEdeQueryName } from 'routes/marketplace-ede/context/edeQueryProvider';

const queryType = 'CREATE_APP';

const useCreateEdeAppMutation = (options: MutationHookOptions = {}) => {
  const queryName = useEdeQueryName(queryType);

  const CREATE_EDE_APP_MUTATION = gql`
    mutation($productAppId: ID!, $payload: CreateAppPayloadInput!) {
      ${queryName} (productAppId: $productAppId, payload: $payload) {
        ${edeApplicationQuery}
      }
    }
  `;

  return useEdeMutation(CREATE_EDE_APP_MUTATION, options);
};

export default useCreateEdeAppMutation;
